import { IChangePasswordRequest } from '../../types/api/request/userrequest';
import {
  IChangePasswordResponse,
  IRetrieveNavigationItemsResponse,
} from '../../types/api/response/userresponse';
import axiosClient from '../axiosClient';
import { UserEndpoint } from '../endpoints/user';

export const UserService = {
  async retrieveNavigationItems(): Promise<IRetrieveNavigationItemsResponse> {
    const res = await axiosClient.get(UserEndpoint.RETRIEVE_NAVIGATION_ITEMS);
    return res.data;
  },

  async changePassword(payload: IChangePasswordRequest): Promise<IChangePasswordResponse> {
    const res = await axiosClient.post(UserEndpoint.CHANGE_PASSWORD, payload);
    return res.data;
  },
};
